/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_UnconfirmedInputs */

const en_portal_x13_error_unconfirmed = /** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your provider has not confirmed this email address. Use the email link instead.`)
};

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const ar_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const he_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const ur_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const es_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const fr_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const de_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const pt_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const hi_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/** @type {(inputs: Portal_X13_Error_UnconfirmedInputs) => LocalizedString} */
const bn_portal_x13_error_unconfirmed = en_portal_x13_error_unconfirmed;

/**
* | output |
* | --- |
* | "Your provider has not confirmed this email address. Use the email link instead." |
*
* @param {Portal_X13_Error_UnconfirmedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_unconfirmed = /** @type {((inputs?: Portal_X13_Error_UnconfirmedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_UnconfirmedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_error_unconfirmed(inputs)
	if (locale === "he") return he_portal_x13_error_unconfirmed(inputs)
	if (locale === "ur") return ur_portal_x13_error_unconfirmed(inputs)
	if (locale === "es") return es_portal_x13_error_unconfirmed(inputs)
	if (locale === "fr") return fr_portal_x13_error_unconfirmed(inputs)
	if (locale === "de") return de_portal_x13_error_unconfirmed(inputs)
	if (locale === "pt") return pt_portal_x13_error_unconfirmed(inputs)
	if (locale === "hi") return hi_portal_x13_error_unconfirmed(inputs)
	if (locale === "bn") return bn_portal_x13_error_unconfirmed(inputs)
	return /** @type {LocalizedString} */ ("Your provider has not confirmed this email address. Use the email link instead.")
});